import {
  AnthropicIcon,
  CohereIcon,
  MetaIcon,
  OpenaiIcon,
} from "@dataone/icons";

export interface IsChatModels {
  key: string;
  label: string;
  icon?: JSX.Element;
  hovered?: boolean;
  description?: string;
  context?: string;
  Input?: string;
  Output?: string;
}

export const chatModels: IsChatModels[] = [
  {
    key: "1",
    label: "claude-instant-1",
    icon: <AnthropicIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "2",
    label: "claude-1",
    icon: <AnthropicIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "3",
    label: "claude-2",
    icon: <AnthropicIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "4",
    label: "11ama7b-v2-chat",
    icon: <MetaIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "5",
    label: "11ama13b-v2-chat",
    icon: <MetaIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "6",
    label: "11ama70b-v2-chat",
    icon: <MetaIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "7",
    label: "command-lifht-nightly",
    icon: <CohereIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "8",
    label: "command-nightly",
    icon: <CohereIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "9",
    label: "OpenAI integration",
    icon: <OpenaiIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
  {
    key: "10",
    label: "OpenAI gpt - 4 - turbo",
    icon: <OpenaiIcon />,
    description:
      "A faster cheaper yet still capable version of Claud, which can handle a range of tasks including casual dialogue , text analysis , summarization, and document comprehension .",
    context: "100.000 tokens",
    Input: "$1.63 / million tokens",
    Output: "$5.51 / million tokens",
  },
];
